<template>
  <v-card
    style="margin:auto;margin-top:50px;height:420px;"
    max-width="1000"
  >
   <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
   </v-overlay>
   <v-card-title style="background-color:#006699;color:white;font-size:16px;">
     <span>Painel de renovação da licença de utilização</span>
     <v-spacer></v-spacer>
      <v-btn to="plano-activo" fab color="primary" small><v-icon>arrow_left</v-icon></v-btn>
    
   </v-card-title>
   
    <v-card-text style="margin-top:30px;margin-left:150px;">
        <v-row>
            <v-col cols="12" md="3">
               <label style="font-size:16px;font-weight:bold;">Plano activo: </label>
            </v-col>
            <v-col cols="12" md="6">
               <label style="font-size:16px;"><v-chip color="primary">{{plano_obj.plano}} </v-chip></label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
               <label style="font-size:16px;font-weight:bold;">Insíra o código fornecido pelo empresa do software: </label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="9">
               <v-text-field
                  label="Código de activação"
                  clearable
                  outlined
                  v-model="chave"
               ></v-text-field>
            </v-col>
        </v-row>
        <small>* Para conseguir activar a sua licença de utilização, terá de estar conectado a internet.</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
        <v-btn :disabled="chave === ''" @click="RenovarLicenca()" color="green" style="color:white;">Renovar licença</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
   
   data: () => ({
      utilitarios:utilitarios,
      plano_obj:null,
      chave:'',
      overlay:false
   }),
   created(){
      this.plano_obj = this.$store.state.plano_obj
      if(this.plano_obj === null ) this.$router.push('plano-activo')
      Swal.fire({icon: 'info',title: 'Para efectuar esta operação deverá estar conectado a internet.'})
   },

   computed:{
      getMacAdress(){
         return ls.get('macadress')
      }
   }, 

   methods:{

     async SearchLicenca(){
         let params = {sistema:'FAT-ESC',chave:this.chave}
         return axios.post('/admin-obter-licenca',params)
      },

      async renovar(params){
         return axios.post('/renovar-licenca',params)
      },

       

      async RenovarLicenca (){
          this.overlay = true
          let licencaObj = await this.SearchLicenca()
          let diasRestantes = utilitarios.ObterNumeroDeDias(this.plano_obj.data_activacao,this.plano_obj.data_expiracao)
          if( licencaObj.data.length >=1 &&  licencaObj.data[0].status_usado === 0){
            let params = 
            {
               chave:licencaObj.data[0].chave,
               dataexpiracao:utilitarios.AdicionarDiasaDataActual(diasRestantes+licencaObj.data[0].duracao),
               mac: this.getMacAdress,
               autor: ls.get('nomeUsuario'),
               empresa_id: ls.get('i_id'),
               empresa: ls.get('empresa')
            }
            try {
               let result = await this.renovar(params)
               if(result.data.affectedRows >= 1 ){
                  Swal.fire({icon: 'success',title: 'Licença de utilização activada com sucesso.'})
                  this.chave = ''
                  this.$router.push('plano-activo')
               }else{
                   Swal.fire({icon: 'warning',title: 'Licença de utilização não activada, esse computador não pode utilizar o sistema.'})
               }
            } catch (error) {
               Swal.fire({icon: 'error',title: 'Ocorreu um erro ao tentar efectuar a operação.'})
            }finally{
               this.overlay = false
            }
          }else{
             this.overlay = false
             Swal.fire({icon: 'warning',title: 'Chave não encontrada'})
          }
      }


   }

}
</script>